import { ConfigState } from './types'

export const initialConfigState: ConfigState = {
	ENVIRONMENT: '',
	API_SERVER: '',
	MESSAGING_API_SERVER: '',
	MESSAGING_WS_SERVER: '',
	LYNXCLOUD_CLIENT: '',
	LYNXADMIN_CLIENT: '',
	LYNXREMOTE_CLIENT: '',
	LYNXACTIVITIES_CLIENT: '',
	LYNXVNC_CLIENT: '',
	CLUSTER_URL: '',
	CLUSTER_URL_HTTP: '',
	API_WS_SERVER: ''
}
